import React from 'react';
import { MainLayout } from 'layouts/MainLayout';
import { LocationScopedSettings } from 'components/settings/LocationScopedSettings';
import { MarketingSettings } from 'components/settings/MarketingSettings';
import { MERCHANT_MOBILE_SETTINGS } from 'config/routes';

export const MarketingSettingsPage: React.FC = () => (
    <MainLayout
        pageName="Marketing Settings"
        pageDescription="Adjust your marketing settings."
        breadcrumbs={[{ label: 'Settings', url: MERCHANT_MOBILE_SETTINGS }]}
    >
        <LocationScopedSettings globalComponent={MarketingSettings} scopedComponent={MarketingSettings} />
    </MainLayout>
);
